import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from 'src/app/shared/components/snackbar/custom-snackbar.component';


@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(
    private readonly snackBar: MatSnackBar
  ) {
  }

  notify(msg: any, type: number) {
    let className = '';
    let icon = '';
    switch (type) {
      case 1:
        className = 'snack-success';
        icon = 'check_circle';
        break;
      case 2:
        className = 'snack-error';
        icon = 'error';
        break;
      case 3:
        className = 'snack-warning';
        icon = 'warning';
        break;
      default:
        className = 'snack-info';
        icon = 'info';
    }

    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: msg,
        icon,
        className
      },
      duration: 3000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: ['easy-snackStyle', className]
    });
  }
}
